import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  RouterStateSnapshot,
} from '@angular/router';
import { TdDialogService } from '@covalent/core/dialogs';
import { take } from 'rxjs/operators';
import { CurrentUser } from 'src/app/core/user.service';
import { Logger } from '../shared-base/amg-ui/logging/logging/logger';
import { AuthenticationService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class UserGuard implements CanActivate, CanActivateChild {
  constructor(
    private _auth: AuthenticationService,
    private _user: CurrentUser,
    private _tdDialog: TdDialogService,
    private _logger: Logger,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.authenticatedUserExists();
  }

  public canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.authenticatedUserExists();
  }

  private async authenticatedUserExists() {
    const authenticatedUser = await this._user.authenticated.valueChanges.pipe(take(1)).toPromise();
    if (authenticatedUser == null) {
      const sub = this._auth.claims.value?.sub;
      this._logger.warning(`User not found: ${sub}`);
      const dialog = this._tdDialog.openAlert({
        title: 'User Not Found',
        disableClose: true,
        message: `Authentication successful, but no user with username "${sub}" has been granted access to this application. If you have used another username or email  to access this application before, try logging out and logging in with that username or email instead.`,
        closeButton: 'Logout',
      });
      await dialog.afterClosed().pipe(take(1)).toPromise();
      await this._auth.logout({ alertText: 'Logged out successfully.' });
      return false;
    }

    return true;
  }
}
